exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-order-styles-___list__header___lNdFB{margin-bottom:0;color:#b18433;font-weight:\"bold\";border:\"none\"}@media (max-width:600px){.src-components-order-styles-___list__header___lNdFB{margin-top:0}}.src-components-order-styles-___list__listItem___2jyXV{padding-top:20px;border-top:1px solid #ccc;padding-bottom:20px}.src-components-order-styles-___list__listItem___2jyXV:first-of-type{border-top:none}.src-components-order-styles-___list__tableHeader___3dgHK{margin:10px 0;font-weight:700}", ""]);

// exports
exports.locals = {
	"header": "src-components-order-styles-___list__header___lNdFB",
	"listItem": "src-components-order-styles-___list__listItem___2jyXV",
	"tableHeader": "src-components-order-styles-___list__tableHeader___3dgHK"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/order/styles/list.scss
 ** module id = 892
 ** module chunks = 0
 **/